<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Staff
            </h2>
            <v-form class="tw-mb-3" name="editForm" ref="editForm">
                <div class="tw-flex tw-gap-3 tw-pb-3">
                    <v-text-field
                        v-model="modelObject.sort_order"
                        label="Sort Order"
                        type="number"
                        :error-messages="errors?.sort_order"
                        hide-details="auto"
                        dense
                        class="tw-w-1/3"
                        clearable
                    ></v-text-field>
                    <v-autocomplete
                        v-model="modelObject.production_staff_role_id"
                        label="Staff Position"
                        :items="valuelists.PRODUCTION_STAFF_ROLES"
                        :error-messages="errors?.production_staff_role_id"
                        :rules="[rules.required]"
                        hide-details="auto"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-autocomplete>
                </div>
                <v-combobox
                    v-model="modelObject.name"
                    label="Name"
                    :items="members"
                    :error-messages="errors?.name"
                    hide-details="auto"
                    outlined
                    dense
                    open-on-clear
                    clearable
                    ref="nameCombobox"
                    :loading="isLoading"
                    :disabled="isLoading"
                ></v-combobox>

            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="archiveProductionStaff()"
                    class="main-btn"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>

export default {
    name: "EditProductionStaffModal",
    components: {
    },
    props: {
        'input': {
            type: Object,
            required: true,
            default: function () {
                return {}
            }
        },
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'valuelists': {
            type: Object,
            required: false
        },
        'members': {
            // The valuelist of members we will rely on
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            dialog: this.value || false,
            production: this.input,
            mode: 'Add',
            modelObject: this.modelProp || {},
            modelDefault: {
                production_id: this.input.id,
                sort_order: undefined,
                production_staff_role_id: null,
                name: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            archiveLoading: false,
            errors: null,
            isLoading: true,
        }
    },
    mounted() {

    },
    computed: {
        dialog_width() {
            return '30%'
        },
        is_edit_mode() {
            return this.mode === 'Edit'
        },
    },
    methods: {
        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            this.modelObject.name = this.$refs.nameCombobox.lazySearch

            if (this.$refs.editForm.validate()) {
                let formData = this.modelObject

                var url = ''
                var method = ''

                if(this.is_edit_mode) {
                    url = route('productionstaff.update', this.modelObject.id)
                    method = 'put'
                } else {
                    url = route('productionstaff.store')
                    method = 'post'
                }

                axios({
                    method: method,
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Staff changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-staff-save')

                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveProductionStaff()
        {
            if (await this.$root.confirm.open(`Delete Staff`, `You are about to delete ${this.modelObject.name}`)) {

                let method = 'delete'
                let url = route('productionstaff.destroy', this.modelObject.id)
                let payload = this.modelObject

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Staff has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-staff-save')

                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.reset()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
        'members'() {
            this.isLoading = false
        }
    },
}
</script>
<style scoped>
</style>
